export default "__VITE_ASSET__f700daa1__"